/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { NetworkInterfaceConfig } from '../models/NetworkInterfaceConfig';
import { RestoreAzureInstanceDiskInput } from '../models/RestoreAzureInstanceDiskInput';

export class AzureVmInstanceRestoreTarget {
  /**
  * Region to restore to.
  */
  'region': string;
  /**
  * Name of the resource group to restore to.
  */
  'resourceGroupName': string;
  /**
  * Restored VM name.
  */
  'vmName': string;
  /**
  * Size of the restored VM.
  */
  'vmSize': string;
  /**
  * Name of the network interface to use (legacy field). Prefer using networkInterfaceConfig for new integrations. If networkInterfaceConfig is provided, this field is ignored. 
  */
  'networkInterface'?: string;
  'networkInterfaceConfig'?: NetworkInterfaceConfig;
  /**
  * Tags to apply to the restored instance as key-value pairs, where key and value are both strings. If not provided, defaults to an empty object, with no tags applied.  **Example:** `{\"eon_api_restore\": \"true\"}` 
  */
  'tags'?: { [key: string]: string; };
  'disks': Array<RestoreAzureInstanceDiskInput>;
  /**
  * Whether to start the VM instance after restoring it. If set to `false`, the VM will be created in a stopped state. 
  */
  'startInstanceAfterRestore'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceGroupName",
      "baseName": "resourceGroupName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vmName",
      "baseName": "vmName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vmSize",
      "baseName": "vmSize",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkInterface",
      "baseName": "networkInterface",
      "type": "string",
      "format": ""
    },
    {
      "name": "networkInterfaceConfig",
      "baseName": "networkInterfaceConfig",
      "type": "NetworkInterfaceConfig",
      "format": ""
    },
    {
      "name": "tags",
      "baseName": "tags",
      "type": "{ [key: string]: string; }",
      "format": ""
    },
    {
      "name": "disks",
      "baseName": "disks",
      "type": "Array<RestoreAzureInstanceDiskInput>",
      "format": ""
    },
    {
      "name": "startInstanceAfterRestore",
      "baseName": "startInstanceAfterRestore",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureVmInstanceRestoreTarget.attributeTypeMap;
  }

  public constructor() {
  }
}

